import { ITabsData } from "ui/tabs/types";

import SelectedAccount from "./content/account";
import SelectedDetails from "./content/details";
import SelectedLoans from "./content/loans";
import SelectedOnDemandPay from "./content/on-demand-pay";
import SelectedSavings from "./content/savings";
import SelectedTransactions from "./content/transactions";

export enum IndividualDetailsTabStatus {
  details = "details",
  account = "account",
  transactions = "transactions",
  loans = "loans",
  savings = "savings",
  "on-demand-pay" = "on-demand-pay",
}

export enum TransactionsSubRouteName {
  TRANSFERS = "transfers",
  BILLS_PAYMENTS = "bills-payments",
  ON_DEMAND_PAY = "odp",
}

export const INDIVIDUAL_DETAILS_TAB_CONTENT_LIST: ITabsData[] = [
  {
    value: IndividualDetailsTabStatus.details,
    content: <SelectedDetails />,
  },
  {
    value: IndividualDetailsTabStatus.account,
    content: <SelectedAccount />,
  },
  {
    value: IndividualDetailsTabStatus.transactions,
    content: <SelectedTransactions />,
  },
  {
    value: IndividualDetailsTabStatus.loans,
    content: <SelectedLoans />,
  },
  {
    value: IndividualDetailsTabStatus.savings,
    content: <SelectedSavings />,
  },
  {
    value: IndividualDetailsTabStatus["on-demand-pay"],
    content: <SelectedOnDemandPay />,
  },
];

export const FREEZE_DROPDOWN_OPTIONS = [
  {
    label: "Reported Fraudulent Activity",
    value: "Reported Fraudulent Activity",
  },
  { label: "Suspicious Activity", value: "Suspicious Activity" },
  { label: "Customer’s Request", value: "Customer’s Request" },
  {
    label: "Security Concern/Compromised Account",
    value: "Security Concern/Compromised Account",
  },
  { label: "Multiple Chargeback Claim", value: "Multiple Chargeback Claim" },
  { label: "Others", value: "Others" },
];

export const MIN_REASON_LENGTH = 5;
export const ZERO = 0;
export const ONE = 1;
export const FIFTY_NINE = 59;
export const ONE_THOUSAND = 1000;
export const TWO_DIGITS = 2;
export const TEN = 10;
export const OPS_EMAIL = "toyosi@earnipay.com";
